import {
  CalendarOutlined,
  CloudServerOutlined,
  ReloadOutlined,
} from '@ant-design/icons';
import { Button, Card, Result } from 'antd';
import { useTranslation } from 'react-i18next';

import 'scenes/RouteReport/components/RouteReportBlockedState.scss';

const I18N_BASE = 'scenes.visit_history';

/** A range without routes is a valid answer, not an error. */
export function VisitHistoryEmptyRange() {
  const { t } = useTranslation();

  return (
    <Card>
      <Result
        icon={
          <span className="route-report-blocked__icon">
            <CalendarOutlined />
          </span>
        }
        title={t(`${I18N_BASE}.empty.title`)}
        subTitle={
          <span className="route-report-blocked__subtitle">
            <span>{t(`${I18N_BASE}.empty.description`)}</span>
            <span className="route-report-blocked__hint">
              {t(`${I18N_BASE}.empty.hint`)}
            </span>
          </span>
        }
      />
    </Card>
  );
}

interface VisitHistoryErrorStateProps {
  onRetry: () => void;
}

/**
 * A load that failed and left nothing to show. The toast lasts 3.5 seconds;
 * without this the screen would look like it is still loading.
 */
export function VisitHistoryErrorState({
  onRetry,
}: VisitHistoryErrorStateProps) {
  const { t } = useTranslation();

  return (
    <Card>
      <Result
        icon={
          <span className="route-report-blocked__icon">
            <CloudServerOutlined />
          </span>
        }
        title={t(`${I18N_BASE}.error.title`)}
        subTitle={
          <span className="route-report-blocked__subtitle">
            <span>{t(`${I18N_BASE}.error.description`)}</span>
            <span className="route-report-blocked__hint">
              {t(`${I18N_BASE}.error.hint`)}
            </span>
          </span>
        }
        extra={
          <Button type="primary" icon={<ReloadOutlined />} onClick={onRetry}>
            {t(`${I18N_BASE}.error.retry`)}
          </Button>
        }
      />
    </Card>
  );
}
